import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Splash } from '@/components/splash';
import { useAuth } from '@/lib/auth/auth-context';
import { clearSignInAttempt, takeReturnTo } from '@/lib/auth/return-to';

/**
 * OIDC landing (OIDC_APP_REDIRECT_URI). The backend has already set the refresh
 * cookie; this is a full page load, so AuthProvider re-runs silent auth. We wait
 * for status, then return the user to the page they originally asked for.
 *
 * On success the attempt marker is cleared, so the loop breaker in
 * ProtectedRoute starts fresh next time. On failure it is deliberately LEFT in
 * place: it is the only thing stopping an OIDC ProtectedRoute from bouncing
 * straight back to the IdP that just refused us. /login is then the retry.
 */
export function CallbackPage() {
  const { status } = useAuth();
  // Read once — takeReturnTo() consumes the value, so it must not run per render.
  const target = useMemo(() => takeReturnTo() ?? '/', []);

  if (status === 'unknown') return <Splash />;
  if (status === 'authenticated') {
    clearSignInAttempt();
    return <Navigate to={target} replace />;
  }
  return <Navigate to="/login" replace />;
}
